import { motion } from "framer-motion";
import { ClipboardList, MapPin, Wrench } from "lucide-react";

const steps = [
  {
    num: "01",
    icon: ClipboardList,
    title: "Décrivez la panne",
    desc: "Indiquez le modèle de votre téléphone et la panne constatée. Devis gratuit et immédiat.",
  },
  {
    num: "02",
    icon: MapPin,
    title: "On se déplace",
    desc: "Un technicien équipé arrive à votre domicile ou à votre bureau, où que vous soyez dans la métropole lyonnaise.",
  },
  {
    num: "03",
    icon: Wrench,
    title: "Réparé en 1h",
    desc: "Réparation sur place, sous vos yeux. Vous ne payez qu'une fois votre téléphone parfaitement fonctionnel.",
  },
];

export const Process = () => {
  return (
    <section id="processus" className="relative py-28 lg:py-40 bg-white border-y border-zinc-200 overflow-hidden" data-testid="process-section">
      <div
        className="pointer-events-none absolute top-0 right-0 h-[400px] w-[600px] rounded-full bg-[#0055FF] opacity-[0.07] blur-[140px]"
        aria-hidden="true"
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p
          className="text-xs uppercase tracking-[0.35em] text-[#0055FF] mb-6"
        >
          Comment ça marche
        </motion.p>
        <motion.h2
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-zinc-950 mb-20"
        >
          Trois étapes,<br /> <span className="text-chrome">zéro déplacement</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {steps.map((step, i) => (
            <motion.article
              key={step.num}
              className="group relative border border-zinc-200 bg-[#F6FAFF] p-10 hover:border-[#0055FF]/50 transition-colors duration-500"
              data-testid={`process-step-${step.num}`}
            >
              <span
                className="font-display text-7xl font-black text-transparent absolute -top-8 right-6 select-none"
                style={{ WebkitTextStroke: "1px rgba(0,0,0,0.1)" }}
                aria-hidden="true"
              >
                {step.num}
              </span>
              <step.icon className="h-8 w-8 text-[#0055FF] mb-8 group-hover:scale-110 transition-transform duration-500" />
              <h3 className="font-display text-2xl font-semibold tracking-tight text-zinc-950 mb-4">
                {step.title}
              </h3>
              <p className="text-base leading-relaxed font-light text-zinc-600">
                {step.desc}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
